<template>
  <draggable :group="group" :sort="false" :list="list" class="draggable-col-container">
    <div v-for="component in list" :key="`component-${component.id}`" class="border-bottom draggable-item">
      <div class="card-body p-0">
        <div class="d-flex align-items-center justify-content-between p-3">
          {{ component.data[itemName] }}
          <div v-b-toggle="`component-${component.id}-options`">
            <fa-icon :icon="['fas', 'ellipsis-v']" fixed-width></fa-icon>
          </div>
        </div>
        <b-collapse :id="`component-${component.id}-options`">
          <div class="p-3 border-top">
            <ul class="m-0 mt-2 pl-4">
              <new-draggable-option-component
                v-for="option in component.data.optionen"
                :key="`option-${option.id}`"
                :option="option"
                :componentId="component.id"
                :componentData="component.data"
                :list="list"
                :getLinkedOptions="component.linkedOptions"
                v-on:savedLinkedOptions="savedLinkedOptions"
              ></new-draggable-option-component> 
            </ul>
          </div>
        </b-collapse>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import NewDraggableOptionComponent from "./NewDraggableOptionComponent.vue";

export default {
  name: "NewDraggableListComponent",
  components: {
    draggable,
    NewDraggableOptionComponent,
  },
  props: {
    group: {
      FooComponenttype: String,
      default: "group",
    },
    itemName: {
      type: String,
      default: "name",
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    savedLinkedOptions(componentId, originOption, linkedOptions) {
      this.$emit("savedLinkedOptions", componentId, originOption, linkedOptions)
    }
  }
  /* data() {
    return {
      components: this.list.map((component) => {
        component.data.optionen = component.data.optionen.map((option) => {
          if (option.linkedOptions === undefined) {
            option.linkedOptions = [];
          }
          return option;
        });
        return component;
      }),
    };
  }, */
};
</script>

<style scoped>
.draggable-col-container {
  height: 398px;
  overflow-y: scroll;
}
.draggable-item {
  cursor: move;
}
</style>
